import React, { useEffect, useState } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { registerPush } from '../../services/pushService';
import ChatbotWidget from '../shared/ChatbotWidget';  
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const Layout = () => {
  const { user, loading } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { registerPush(); }, []); 

  // Fermer automatiquement le menu mobile lors d'un changement de page
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  if (loading) {
    return <div className="loading"><div className="spinner" /></div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="app-layout">
      <Sidebar 
        isOpen={mobileMenuOpen} 
        onClose={() => setMobileMenuOpen(false)} 
      />
      <div className="main-content">
        <Topbar 
          onToggleSidebar={() => setMobileMenuOpen((prev) => !prev)} 
        />
        <div className="page-content">
          <Outlet />
        </div>
      </div>  
      <ChatbotWidget />  
    </div>
  );
};

export default Layout;
